import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from "react-helmet"
import favicon from "../images/favicon.svg"
import Div100vh from "react-div-100vh"
import { ThinkingFace } from "react-blobmoji"

import Header from "./header"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)

  return (
    <Div100vh className="font-sans flex flex-col leading-normal">
      <Helmet>
        <link rel="shortcut icon" href={favicon} />
        <link rel="author" href="http://www.hatena.ne.jp/miiton/" />
      </Helmet>
      <header className="shadow-sm">
        <div className="container mx-auto">
          <Header siteMetaData={data.site.siteMetadata} />
        </div>
      </header>
      <main className="flex-grow">{children}</main>
      <footer className="flex-0 py-2 bg-zinc-100 relative flex items-center">
        <div className="container mx-auto flex justify-center text-center items-center">
          <span className="mx-4">
            &copy; {new Date().getFullYear()} @miiton
          </span>
        </div>
        <ThinkingFace className="absolute right-0" />
      </footer>
    </Div100vh>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
